import { Icon } from '@chakra-ui/react';

export default function SFListCheckIcon(props) {
  return (
    <Icon
      width={5}
      height={5}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.6547 7.78354H3.69588C3.31315 7.78354 3 8.09669 3 8.47942C3 8.86216 3.31315 9.17531 3.69588 9.17531H10.6547C11.0375 9.17531 11.3506 8.86216 11.3506 8.47942C11.3506 8.09669 11.0375 7.78354 10.6547 7.78354ZM10.6547 5H3.69588C3.31315 5 3 5.31315 3 5.69588C3 6.07862 3.31315 6.39177 3.69588 6.39177H10.6547C11.0375 6.39177 11.3506 6.07862 11.3506 5.69588C11.3506 5.31315 11.0375 5 10.6547 5ZM3.69588 11.9588H7.87119C8.25393 11.9588 8.56708 11.6457 8.56708 11.263C8.56708 10.8802 8.25393 10.5671 7.87119 10.5671H3.69588C3.31315 10.5671 3 10.8802 3 11.263C3 11.6457 3.31315 11.9588 3.69588 11.9588ZM17.0638 9.32144L17.1265 9.38407C17.3978 9.65547 17.3978 10.0939 17.1265 10.3653L13.2434 14.2553C12.972 14.5267 12.5336 14.5267 12.2622 14.2553L10.1119 12.105C9.84054 11.8336 9.84054 11.3952 10.1119 11.1238L10.1746 11.0612C10.446 10.7898 10.8844 10.7898 11.1558 11.0612L12.7563 12.6617L16.0826 9.3284C16.3471 9.05005 16.7924 9.05005 17.0638 9.32144Z'
        fill='currentColor'
      />
    </Icon>
  );
}
